import api from './client'

export const listasApi = {
  listar: () => api.get('/listas-precios'),
  obtener: (id) => api.get(`/listas-precios/${id}`),
  actualizar: (id, data) => api.put(`/listas-precios/${id}`, data),
  items: (id, params) => api.get(`/listas-precios/${id}/items`, { params }),
  actualizarPrecio: (listaId, articuloId, precio) =>
    api.put(`/listas-precios/${listaId}/items/${articuloId}`, { precio }),
}

export const articuloPreciosApi = {
  listar: (articuloId) => api.get(`/articulos/${articuloId}/precios`),
  actualizar: (articuloId, listaId, precio) =>
    api.put(`/articulos/${articuloId}/precios/${listaId}`, { precio }),
}
